//@ts-check
import React from 'react'
import { Tooltip } from '@progress/kendo-react-tooltip'
import { Link } from 'react-router-dom/cjs/react-router-dom'

/**
 * @param {Object} props
 * @param {Object} props.params - The parameters to be passed in the link.
 * @param {string} props.pathname - The pathname for the link.
 * @param {string} props.tooltipTracking - The tooltip text for the tracking icon.
 * @param {string} [props.className] - Optional additional class names for styling.
 * @returns {JSX.Element} The Tracking component rendering a link with a tooltip.
 */
const Tracking = ({ className = '', params = {}, pathname = '', tooltipTracking = '' }) => {
    return (
        <div className={className}>
            <Link
                to={{
                    pathname,
                    params,
                }}
            >
                <Tooltip openDelay={600} position='top' anchorElement='target' tooltipClassName='tooltipGeneralStyle'>
                    <img
                        title={tooltipTracking}
                        src='https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_tracking_document.png'
                        width={20}
                        alt='tracking-icon'
                    />
                </Tooltip>
            </Link>
        </div>
    )
}

export default Tracking